// extracted by mini-css-extract-plugin
module.exports = {"mainWidth":"mainWidth--1PqI1","pageWrap":"pageWrap--2wsKE"};